import { useTheme } from "../../../context/useThemeContext";
import { hexToRGBA } from "../../../utility/hexToRGB";

export function Seperator() {
    const { theme } = useTheme();

    return (
        <div
            className="icon-separator w-[1px] h-[16px] mx-[2px] "
            style={{
                backgroundColor: hexToRGBA(theme.fontColor[100], 0.2),
            }} />
    );
}
